import React from "react";
import ButtonComponent from "../../components/Button";
import { useNavigate } from "react-router-dom";

import { CloseMedium } from "@vibe/icons";
const CancelAuthPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate("/onboarding");
  };

  return (
    <section>
      <div className="flex items-center justify-center w-full min-h-[225px] welcome-page-hero">
        <div className="w-[72px] h-[72px] flex items-center bg-white justify-center shadow-welcome-check rounded-full">
          <CloseMedium size={46} color="#B63546" />
        </div>
      </div>

      <div className="py-5">
        <div className="mx-auto text-center max-w-[600px]">
          <div className="mb-4">
            <h3 className="!font-figtree font-semibold">Authorization Required</h3>
            <p className="!font-figtree text-sm !mt-2">
              You need to authorize your account <br />
              to use <b>Same Item Multiple Boards</b>.
            </p>
            {/* <p className="!font-figtree text-sm !mt-2">
          Thank you for installing the SIMB, we’re excited to have you on board! <br />
          Click on “Start Guided Tour” to get to know SIMB features better.
        </p> */}
          </div>

          <div className="flex items-center justify-center gap-4 mx-auto mt-1">
            {/* <ButtonComponent onClick={() => handleTour(false)} text="Skip Tour" kind="tertiary" /> */}
            {/* <ButtonComponent onClick={() => handleTour(true)} text="Start Guided Tour" /> */}

            <ButtonComponent onClick={() => handleGoBack()} text="Go back to authorization" kind="primary" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CancelAuthPage;
